import { Fragment } from 'react';
import { Link } from '@tanstack/react-router';
import { HomeIcon } from 'lucide-react';
import { LinkProtected } from '@r/components/link-protected/link-protected.tsx';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
} from '@ui/breadcrumb.tsx';

export type BreadcrumbItemType = {
  label: string;
  to?: string;
  params?: Record<string, string>;
  isCurrentPage?: boolean;
};

type BreadcrumbNavigationProps = {
  items: BreadcrumbItemType[];
  showHome?: boolean;
  className?: string;
};

const BreadcrumbNavigation = ({ items, showHome = true, className }: BreadcrumbNavigationProps) => {
  return (
    <Breadcrumb className={className}>
      <BreadcrumbList>
        {showHome && (
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <LinkProtected to="/">
                <HomeIcon size={15} />
              </LinkProtected>
            </BreadcrumbLink>
          </BreadcrumbItem>
        )}

        {showHome && items.length > 0 && <BreadcrumbSeparator />}

        {items.map((item, index) => (
          <Fragment key={`breadcrumb-${index}`}>
            {index > 0 && <BreadcrumbSeparator />}
            <BreadcrumbItem>
              {item.isCurrentPage ? (
                <BreadcrumbPage>{item.label}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink asChild>
                  {item.to ? (
                    <Link to={item.to} params={item.params || {}}>
                      {item.label}
                    </Link>
                  ) : (
                    <span>{item.label}</span>
                  )}
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export { BreadcrumbNavigation };
